import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tab } from '@material-ui/core';

import useStyles from './header-tab.styles';

const MenuItem = ({ iconSize, iconSrc, label, ...props }) => {
  const classes = useStyles();
  const tabClasses = useMemo(() => {
    const { smallIcon, largeIcon, label: labelClass, ...otherClasses } = classes;
    return otherClasses;
  }, [classes]);
  return (
    <Tab
      classes={tabClasses}
      label={
        <>
          <img className={iconSize === 'large' ? classes.largeIcon : classes.smallIcon} src={iconSrc} alt={label} />
          <span className={classes.label}>{label}</span>
        </>
      }
      {...props}
    />
  );
};

MenuItem.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  iconSize: PropTypes.oneOf(['large', 'small'])
};

MenuItem.defaultProps = {
  iconSize: 'large'
};

export default MenuItem;
